export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#0F1424" stroke="rgba(0,240,255,0.25)" />
    <g stroke="#00F0FF" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 40 L32 22 L44 34" />
      <path d="M20 40 L30 46 L44 34" />
    </g>
    <circle cx="32" cy="22" r="4.5" fill="#00F0FF" />
    <circle cx="20" cy="40" r="4" fill="#0F1424" stroke="#00F0FF" strokeWidth="2.5" />
    <circle cx="44" cy="34" r="4" fill="#0F1424" stroke="#00F0FF" strokeWidth="2.5" />
    <circle cx="30" cy="46" r="3.5" fill="#7C3AED" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-lg font-extrabold tracking-tight text-white">
      Lead<span className="text-volt">Cerebro</span>
    </span>
  </span>
);
